import { Link } from "react-router-dom";
import { CalendarCheck } from "lucide-react";
import { Button } from "@/components/ui/button";

export const StickyBookNow = () => {
  return (
    <div className="fixed bottom-6 right-6 z-40 md:hidden" data-testid="sticky-book-now">
      <Link to="/bet-cabin">
        <Button className="bg-accent hover:bg-accent/90 text-white rounded-full shadow-lg shadow-accent/30 px-5 py-3 h-auto font-body text-sm flex items-center gap-2">
          <CalendarCheck size={18} />
          Book Now
        </Button>
      </Link>
    </div>
  );
};
